// removed by extract-text-webpack-plugin
module.exports = {"vadpLoginForHXYY_KYYZXJFCXXT":"vadpLoginForHXYY_KYYZXJFCXXT___1lNjJ","pic":"pic___2wlxG","container":"container___3htzW","logo":"logo___2itr7","title":"title___2akBf","autofill-fix":"autofill-fix___6EQuV","vadpLogin":"vadpLogin___1994f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForHXYY_KYYZXJFCXXT/index.less
// module id = 354
// module chunks = 0